export default __webpack_public_path__ + "static/media/house_big.93e4e078.svg";